<template>
  <!-- Session Contents -->
  <v-layout>
    <!-- Right menu -->
    <RightMenu />
    <!-- Tool bar 1 -->
    <FirstToolbar />
    <!-- Left menu-->
    <LeftMenu />
    <!-- Tool bar 2 -->
    <SecondToolbar />
    <!-- Content -->
    <v-main>
      <v-container
        fluid
        :class="{
          'px-12': $vuetify.display.mdAndUp,
          'px-4': $vuetify.display.sm,
          'px-1': $vuetify.display.xs
        }"
        class="mt-4 py-6"
      >
        <!-- メインコンテンツ -->
        <router-view />
      </v-container>
    </v-main>
  </v-layout>
</template>

<script>
  import FirstToolbar from '@/components/base/TheFirstToolbar'
  import SecondToolbar from '@/components/base/TheSecondToolbar'
  import LeftMenu from '@/components/base/TheLeftMenu'
  import RightMenu from '@/components/base/TheRightMenu'

  export default {
    components: {
      FirstToolbar,
      SecondToolbar,
      LeftMenu,
      RightMenu
    }
  }
</script>
